/* MAOMAO Age-Gate v1 (260709)
   Eigenbau-Altersabfrage 18+ fuer Alkohol-Produkte (ersetzt App "NA Age Verification").
   - Trigger 1 (PDP): maomao-tabbar setzt window.__mmAlcPDP=true, wenn product.tags 'Alcohol' enthaelt.
   - Trigger 2 (Warenkorb): auf JEDER Seite wird der Cart geprueft (auch Quick-Add von Kacheln,
     Wishlist etc.): /cart.js -> unbekannte Handles via /products/{handle}.js auf Tag 'Alcohol'
     pruefen (Ergebnis in sessionStorage mm_alc_map gecacht).
   - "Ja" => localStorage mm_age18_until = jetzt+30 Tage (nur lokal, DSGVO-ok, kein Fremd-Script).
   - "Nein" => alle Alkohol-Positionen werden aus dem Warenkorb entfernt, Redirect zur Startseite.
   - Im Theme-Editor (Shopify.designMode) deaktiviert.
   - Rechtlich massgeblich bleibt die Alterssichtpruefung 18+ bei DHL-Zustellung (Versandprofil!).
   - Texte deutsch; Design v5 (Montserrat erbt vom Theme, Markenrot #E63B2E). */
(function(){
  'use strict';
  if(window.Shopify&&Shopify.designMode)return;
  var TAG='Alcohol';
  var KEY='mm_age18_until';
  var DAYS30=30*24*60*60*1000;
  function confirmed(){try{return parseInt(localStorage.getItem(KEY)||'0',10)>Date.now();}catch(e){return false;}}
  if(confirmed())return;

  var alcCache={};
  try{alcCache=JSON.parse(sessionStorage.getItem('mm_alc_map')||'{}');}catch(e){}
  function saveCache(){try{sessionStorage.setItem('mm_alc_map',JSON.stringify(alcCache));}catch(e){}}

  var shown=false;
  function css(){
    if(document.getElementById('mm-age-css'))return;
    var s=document.createElement('style');s.id='mm-age-css';
    s.textContent='.mm-age{position:fixed;inset:0;z-index:10990;display:flex;align-items:center;justify-content:center;padding:18px}'+
    '.mm-age__scrim{position:absolute;inset:0;background:rgba(22,17,14,.68);-webkit-backdrop-filter:blur(3px);backdrop-filter:blur(3px)}'+
    '.mm-age__box{position:relative;background:#fff;border-radius:20px;max-width:400px;width:100%;padding:30px 26px 22px;text-align:center;box-shadow:0 24px 60px -12px rgba(34,26,22,.45);animation:mmAgeIn .22s ease-out}'+
    '@keyframes mmAgeIn{from{transform:translateY(14px);opacity:0}to{transform:none;opacity:1}}'+
    '.mm-age__badge{width:58px;height:58px;border-radius:50%;background:#E63B2E;color:#fff;font-weight:900;font-size:19px;display:flex;align-items:center;justify-content:center;margin:0 auto 14px;letter-spacing:-.02em}'+
    '.mm-age__box h2{margin:0 0 8px;font-size:20px;font-weight:800;color:#221A16}'+
    '.mm-age__box p{margin:0 0 18px;font-size:13.5px;line-height:1.55;color:#5C4E44}'+
    '.mm-age__btns{display:flex;flex-direction:column;gap:9px}'+
    '.mm-age__yes{background:#E63B2E;color:#fff;border:0;border-radius:12px;padding:13px 16px;font-size:14px;font-weight:800;cursor:pointer;font-family:inherit;transition:background .15s}'+
    '.mm-age__yes:hover{background:#C42A1F}'+
    '.mm-age__no{background:#fff;color:#5C4E44;border:1.5px solid #EADFD3;border-radius:12px;padding:12px 16px;font-size:13.5px;font-weight:700;cursor:pointer;font-family:inherit}'+
    '.mm-age__no:hover{border-color:#9A8B83}'+
    '.mm-age__fine{margin:14px 0 0!important;font-size:10.5px!important;line-height:1.5!important;color:#9A8B83!important}';
    document.head.appendChild(s);
  }
  function removeAlcohol(items,done){
    var alc=items.filter(function(it){return alcCache[it.handle]===true;});
    if(!alc.length){done();return;}
    var i=0;
    (function next(){
      if(i>=alc.length){document.dispatchEvent(new CustomEvent('cart:change'));done();return;}
      var it=alc[i++];
      fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:it.key,quantity:0})})
        .then(function(){next();}).catch(function(){next();});
    })();
  }
  function show(cartItems){
    if(shown||confirmed())return;shown=true;
    css();
    var w=document.createElement('div');
    w.className='mm-age';w.setAttribute('role','dialog');w.setAttribute('aria-modal','true');w.setAttribute('aria-label','Altersprüfung');
    w.innerHTML='<div class="mm-age__scrim"></div>'+
      '<div class="mm-age__box">'+
      '<div class="mm-age__badge">18+</div>'+
      '<h2>Altersprüfung</h2>'+
      '<p>Dieser Artikel enthält Alkohol. Der Verkauf alkoholischer Getränke ist nur an Personen ab 18 Jahren erlaubt.</p>'+
      '<div class="mm-age__btns">'+
      '<button type="button" class="mm-age__yes">Ja, ich bin mindestens 18 Jahre alt</button>'+
      '<button type="button" class="mm-age__no">Nein, ich bin unter 18</button>'+
      '</div>'+
      '<p class="mm-age__fine">Dein Alter wird bei der Zustellung zusätzlich durch den Versanddienstleister geprüft (Alterssichtprüfung 18+). Deine Bestätigung wird nur lokal auf deinem Gerät gespeichert (30 Tage) und nicht an Dritte weitergegeben.</p>'+
      '</div>';
    document.body.appendChild(w);
    document.documentElement.style.overflow='hidden';
    function close(){document.documentElement.style.overflow='';w.remove();shown=false;}
    w.querySelector('.mm-age__yes').addEventListener('click',function(){
      try{localStorage.setItem(KEY,String(Date.now()+DAYS30));}catch(e){}
      close();
    });
    w.querySelector('.mm-age__no').addEventListener('click',function(){
      var btn=w.querySelector('.mm-age__no');btn.disabled=true;btn.textContent='…';
      removeAlcohol(cartItems||[],function(){window.location.href='/';});
    });
    setTimeout(function(){try{w.querySelector('.mm-age__yes').focus();}catch(e){}},50);
  }
  function isAlc(handle){
    if(handle in alcCache)return Promise.resolve(alcCache[handle]);
    return fetch('/products/'+handle+'.js')
      .then(function(r){if(!r.ok)throw 0;return r.json();})
      .then(function(p){var a=(p.tags||[]).indexOf(TAG)>-1;alcCache[handle]=a;saveCache();return a;})
      .catch(function(){return false;});
  }
  var checking=false;
  function checkCart(){
    if(confirmed()||shown||checking)return;checking=true;
    fetch('/cart.js').then(function(r){return r.json();}).then(function(c){
      var items=(c.items||[]).map(function(it){return {handle:it.handle,key:it.key};});
      return Promise.all(items.map(function(it){return isAlc(it.handle);})).then(function(flags){
        checking=false;
        if(flags.some(Boolean))show(items);
      });
    }).catch(function(){checking=false;});
  }
  function debounced(){setTimeout(checkCart,900);}
  ['cart:change','cart:updated','cart:refresh','cart:build','ajaxProduct:added'].forEach(function(ev){document.addEventListener(ev,debounced);});
  if(window.__mmAlcPDP){show([]);}
  setTimeout(checkCart,800);
})();
